export default {
  state: {
    resources: [],
    selectedResourceIds: [],
  },
  getters: {
    resources: (state: any) => {
      return state.resources;
    },
    selectedResourceIds: (state: any) => {
      return state.selectedResourceIds;
    },
    selectedResources: (state: any) => {
      const { resources, selectedResourceIds } = state;
      return resources.filter(({ resourceId }) => selectedResourceIds.includes(resourceId));
    },
    selectedAllResources: (state: any) => {
      const { resources, selectedResourceIds } = state;
      return resources.length === selectedResourceIds.length;
    },
  },
  mutations: {
    updateResources: (state: any, value: any) => {
      state.resources = value || [];
    },
    updateSelectedResourceIds: (state: any, value: any) => {
      state.selectedResourceIds = value || [];
    },
    resetSelectedResourceIds: (state: any) => {
      const { resources } = state;
      state.selectedResourceIds = resources.map(({ resourceId }) => resourceId);
    },
  },
};
